/**
 * useGuestStorage — localStorage adapter for guest goal persistence.
 */
import { Goal } from "@/types/todo";
import { logger } from '@/utils/logger';

const GUEST_GOALS_KEY = 'guestGoals';

export const useGuestStorage = () => {
  const loadGoals = (): Goal[] => {
    try {
      const storedGoals = localStorage.getItem(GUEST_GOALS_KEY);
      return storedGoals ? JSON.parse(storedGoals) : [];
    } catch (error) {
      logger.error('Error loading goals from localStorage:', error);
      return [];
    }
  };

  const saveGoals = (goals: Goal[]): void => {
    try {
      localStorage.setItem(GUEST_GOALS_KEY, JSON.stringify(goals));
    } catch (error) {
      logger.error('Error saving goals to localStorage:', error);
    }
  };

  return {
    loadGoals,
    saveGoals
  };
};
